import React from 'react';
import { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Empty, Skeleton } from 'antd';
import { Duration } from './Duration';
import { Footer } from '../../Footer';
import { CategoryContext } from './context';
import { useRosaContext } from '../../../../context';
import { RosaCategoriesEnum } from '../../../../types';
import { SubCategorySection } from './SubCategorySection';
import { useGetElements } from '../../../../hooks/useGetElements';
import { useGetRosaScores } from '@/components/views/Report/Rosa/hooks';
import type { GetRosaCategoriesResponse, RosaSubCategory } from '../../../../hooks/useGetRosaCategories';
import * as S from './styles';

interface CategorySectionProps {
	category: GetRosaCategoriesResponse;
}

export function CategorySection({ category }: Readonly<CategorySectionProps>) {
	const { sub_categories } = category;
	const { organization_id, company_id, report_id } = useRosaContext();

	const { data } = useGetRosaScores({
		organization_id,
		company_id,
		report_id
	});

	const [selectedSubCategory, setSelectedSubCategory] = useState<RosaSubCategory>(sub_categories[0]);

	const {
		isError,
		isLoading,
		data: subCategoriesElements
	} = useGetElements({
		organization_id,
		company_id,
		category_id: category.id
	});

	if (isLoading) {
		return <Skeleton active />;
	}

	if (isError) {
		return <Empty />;
	}

	const fieldName = ['evaluation', category.name, selectedSubCategory.name];

	const context = {
		category,
		fieldName,
		selectedSubCategory,
		subCategoriesElements,
		elements: subCategoriesElements?.[selectedSubCategory.name]
	};

	function isChairCategory() {
		return category.name === RosaCategoriesEnum.CHAIR;
	}

	return (
		<CategoryContext.Provider value={context}>
			<S.Container gutter={[0, 20]}>
				<Col span={24}>
					<S.Header align="middle" gutter={[20, 0]}>
						{sub_categories.map((subCategory) => {
							return (
								<Col key={subCategory.id}>
									<S.CustomButton
										type="ghost"
										onClick={() => setSelectedSubCategory(subCategory)}
										$isSelected={selectedSubCategory.id === subCategory.id}
									>
										{I18n.get(subCategory.description)}
									</S.CustomButton>
								</Col>
							);
						})}
					</S.Header>
				</Col>
				<Col span={24}>
					<SubCategorySection />
				</Col>

				{isChairCategory() && (
					<Col span={24}>
						<Duration />
					</Col>
				)}
			</S.Container>
			<Row justify="center" style={{ marginTop: 32 }}>
				<Col span={24}>
					<Footer isNextDisabled={!data?.final_score} />
				</Col>
			</Row>
		</CategoryContext.Provider>
	);
}
